import { render, staticRenderFns } from "./subBidEvaluationReportPreparation.vue?vue&type=template&id=38222122&scoped=true"
import script from "./subBidEvaluationReportPreparation.vue?vue&type=script&lang=js"
export * from "./subBidEvaluationReportPreparation.vue?vue&type=script&lang=js"
import style0 from "./subBidEvaluationReportPreparation.vue?vue&type=style&index=0&id=38222122&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38222122",
  null
  
)

export default component.exports